<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-case code="fausse-declaration" v-model="permisPsychologue.fausseDeclaration" :live="liveSasPermisPsychologue(2115)"></opq-case>
    <opq-case code="renseignements-exacts" v-model="permisPsychologue.renseignementsExacts" :live="liveSasPermisPsychologue(2118)"></opq-case>
    <opq-case
      code="autorise-echange-informations"
      v-model="permisPsychologue.autoriseEchangeInformations"
      :live="liveSasPermisPsychologue(2119)"
    ></opq-case>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
export default {
  mixins: [FormSimple],
  props: {
    sas: { type: Object }
  },

  computed: {
    permisPsychologue() {
      return this.sas.permisPsychologue
    }
  },

  methods: {
    liveSasPermisPsychologue(cle) {
      return { endpoint: "/sas-permis-psychologue/", cle: cle, fileId: this.permisPsychologue.id }
    }
  }
}
</script>

<style>
</style>